module.exports = __webpack_public_path__ + "d6.no2.e0922faf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d6.no2.jpg
// module id = zvo+
// module chunks = 0